import { IRegistrationByDayInterface } from '../models/registrations-by-day/registrationByDay.interface'
import { IRegistrationTicketInterface } from '../models/registration-tickets/registrationTicket.interface'
import { IRegistrationFeesInterface } from '../models/registration-fees/registrationFees.interface'
import { IRiderTeamMemberInterface } from '../models/rider-team-member/riderTeamMember.interface'

export type IPaymentStatus = 'paid' | null
export type IPaymentType = 'cash' | 'check' | 'card' | 'us_bank_account' | 'paypal' | 'venmo' | null

export const PAYMENT_STATUS_VALUES = {
  PAID: 'paid',
  DEFAULT: null,
}
export const PAYMENT_STATUS = {
  PAID: 'paid' as IPaymentStatus,
  DEFAULT: null as IPaymentStatus,
}

export const PAYMENT_TYPE = {
  CASH: 'cash' as IPaymentType,
  CHECK: 'check' as IPaymentType,
  CARD: 'card' as IPaymentType,
  PAYPAL: 'paypal' as IPaymentType,
  VENMO: 'venmo' as IPaymentType,
  DEFAULT: null as IPaymentType,
}

export type IScratchedItem = {
  scratchedItems: {
    docId: string
    recipientId: string
    recipientName: string
    recipientProfilePicture: string
    amountScratched: number
  }[]
  scratchTotal: number
  scratchTotalSalesTax: number
}

export type IScratchPayload = {
  registrationDocId: string
  scratchedRegistrationByDayItems: IScratchedItem['scratchedItems']
  scratchedFeesItems: IScratchedItem['scratchedItems']
  scratchedTicketItems: IScratchedItem['scratchedItems']
  isChargeSalesTax: boolean
  // we need it for unScratch functionality
  isAlreadyScratched: boolean
}

export type IRefundPaymentInfo = {
  recipientId: string
  chargeId: string
  invoiceUrl: string
}

type IRefundItem = {
  docId: string
  amountToRefund: number
  salesTax: number
  invoiceId: string
}

export type IRefundPayload = {
  comment: string
  registrationDocId: string
  paymentInfo: IRefundPaymentInfo[]
  scratchedFeesItems: IRefundItem[]
  scratchedTicketItems: IRefundItem[]
  scratchedRegistrationByDayItems: IRefundItem[]
  reason: 'duplicate' | 'fraudulent' | 'requested_by_customer'
  eventOwnerId: string
}

export type IOnPayload = {
  paymentType: IPaymentType
  paymentStatus: IPaymentStatus
  amountToPay: number
  pmId: string | null
  cardNumber: string | null
  description: string
  type: string
  registrationId?: string | null
  registrationsByDay: IRegistrationByDayInterface[]
  tickets: IRegistrationTicketInterface[]
  fees: IRegistrationFeesInterface[]
  ridersTeamMembers: IRiderTeamMemberInterface[]
  payerId: string | null
  registrarId?: string | null
  eventId?: string | null
  isTicketPayment: boolean
}

export type IUndoOnPayload = {
  eventId: string
  payerId: string
  registrationId: string
  paymentType: IPaymentType
  registrationsByDay: IRegistrationByDayInterface[]
  fees: IRegistrationFeesInterface[]
  tickets: IRegistrationTicketInterface[]
}

export type IPaymentMethodOptions = 'credit-card' | 'ach' | 'delayed' | 'cash'
